import workEntries from "./workEntries"
const getStatus = (date) => {
    let d1 = new Date(date)
    let month = d1.getMonth()
    return month === 0
}
export const workDays = [
    {
        "id": "0d8a9793-25b8-4fbe-ae53-3c8f4dc6649f",
        "date": "2024-01-01",
        "compensation": 5,
        "contractWorkLoad": 6,
        "submitted": true
    },
    {
        "id": "3ca19499-ae0f-4551-8440-3bd71ddc5222",
        "date": "2024-01-02",
        "compensation": 6,
        "contractWorkLoad": 2,
        "submitted": false
    },
    {
        "id": "8033469f-4cc0-418c-917e-0f49e34d9915",
        "date": "2024-01-03",
        "compensation": 4,
        "contractWorkLoad": 5,
        "submitted": false
    },
    {
        "id": "c5a09e15-74f3-465b-99ec-5277daaa5767",
        "date": "2024-01-04",
        "compensation": 5,
        "contractWorkLoad": 2,
        "submitted": true
    },
    {
        "id": "83328a04-03b4-4590-9d36-83c1809617da",
        "date": "2024-01-05",
        "compensation": 8,
        "contractWorkLoad": 7,
        "submitted": false
    },
    {
        "id": "782c03ea-fcb7-427c-9b2d-07e278788473",
        "date": "2024-01-06",
        "compensation": 1,
        "contractWorkLoad": 6,
        "submitted": true
    },
    {
        "id": "c999e0a0-059f-44fb-b989-98af2cf6f043",
        "date": "2024-01-07",
        "compensation": 7,
        "contractWorkLoad": 2,
        "submitted": true
    },
    {
        "id": "ac2db961-2a72-457e-a413-c4f3ab50ce49",
        "date": "2024-01-08",
        "compensation": 0,
        "contractWorkLoad": 4,
        "submitted": false
    },
    {
        "id": "bd4995ac-6587-49fd-9775-da531587b692",
        "date": "2024-01-09",
        "compensation": 0,
        "contractWorkLoad": 1,
        "submitted": false
    },
    {
        "id": "cb93494c-6320-4218-8917-f0dc81818fad",
        "date": "2024-01-10",
        "compensation": 4,
        "contractWorkLoad": 7,
        "submitted": false
    },
    {
        "id": "49285ffa-d9f2-4824-a493-22d7e17d32c7",
        "date": "2024-01-11",
        "compensation": 0,
        "contractWorkLoad": 2,
        "submitted": false
    },
    {
        "id": "489ab423-bea7-4547-a43f-89b6007e293e",
        "date": "2024-01-12",
        "compensation": 4,
        "contractWorkLoad": 1,
        "submitted": true
    },
    {
        "id": "30b39370-869e-4ab5-98c5-312a98112683",
        "date": "2024-01-13",
        "compensation": 5,
        "contractWorkLoad": 5,
        "submitted": true
    },
    {
        "id": "1f84931a-630e-4b4e-ae37-6b8a22c16001",
        "date": "2024-01-14",
        "compensation": 2,
        "contractWorkLoad": 4,
        "submitted": false
    },
    {
        "id": "da81978c-23ef-4e5f-b293-cf582b6b1052",
        "date": "2024-01-15",
        "compensation": 0,
        "contractWorkLoad": 1,
        "submitted": true
    },
    {
        "id": "a493cddf-a0a6-45ac-926c-61f1bd9b3a66",
        "date": "2024-01-16",
        "compensation": 5,
        "contractWorkLoad": 7,
        "submitted": false
    },
    {
        "id": "c3339336-f1d4-46f4-b584-5ffcec4d55d5",
        "date": "2024-01-17",
        "compensation": 7,
        "contractWorkLoad": 2,
        "submitted": true
    },
    {
        "id": "b963d081-4686-4f1f-82c7-a07a3e6a5c73",
        "date": "2024-01-18",
        "compensation": 2,
        "contractWorkLoad": 7,
        "submitted": false
    },
    {
        "id": "fb43f71e-697f-4002-b0e6-310d1e131151",
        "date": "2024-01-19",
        "compensation": 8,
        "contractWorkLoad": 7,
        "submitted": true
    },
    {
        "id": "f40701bb-23b7-462f-9046-d8baaedcdb72",
        "date": "2024-01-20",
        "compensation": 7,
        "contractWorkLoad": 7,
        "submitted": false
    },
    {
        "id": "fcf5ccbb-7709-434a-adda-708c76e529a9",
        "date": "2024-01-21",
        "compensation": 1,
        "contractWorkLoad": 4,
        "submitted": false
    },
    {
        "id": "6f8bfd15-150c-4e75-ad87-6216ae40bb1f",
        "date": "2024-01-22",
        "compensation": 3,
        "contractWorkLoad": 3,
        "submitted": false
    },
    {
        "id": "7b5562d9-f532-4213-a18d-b8c4a4b41b46",
        "date": "2024-01-23",
        "compensation": 0,
        "contractWorkLoad": 4,
        "submitted": true
    },
    {
        "id": "7e5d8659-41f3-4534-b687-0ddacd874a0e",
        "date": "2024-01-24",
        "compensation": 1,
        "contractWorkLoad": 5,
        "submitted": true
    },
    {
        "id": "ef41fd18-a101-4af4-a74b-3feeb3fee0cc",
        "date": "2024-01-25",
        "compensation": 2,
        "contractWorkLoad": 4,
        "submitted": true
    },
    {
        "id": "14798ac5-b351-4fcc-9a73-850b80c5d4e7",
        "date": "2024-01-26",
        "compensation": 7,
        "contractWorkLoad": 2,
        "submitted": true
    },
    {
        "id": "b68a624c-0ca0-43fa-aeff-4cec6c1c1f26",
        "date": "2024-01-27",
        "compensation": 3,
        "contractWorkLoad": 2,
        "submitted": false
    },
    {
        "id": "347525fa-7c3f-4cba-a18e-e837b9f97425",
        "date": "2024-01-28",
        "compensation": 4,
        "contractWorkLoad": 1,
        "submitted": false
    },
    {
        "id": "dfb6f636-f98e-4169-a3a8-d3935837cc08",
        "date": "2024-01-29",
        "compensation": 5,
        "contractWorkLoad": 7,
        "submitted": false
    },
    {
        "id": "aeebf35d-dad8-46ad-b425-579d77eeee3d",
        "date": "2024-01-30",
        "compensation": 1,
        "contractWorkLoad": 1,
        "submitted": false
    },
    {
        "id": "4edf849c-620d-4005-9ea3-fdd86440ccc4",
        "date": "2024-01-31",
        "compensation": 2,
        "contractWorkLoad": 5,
        "submitted": false
    },
    {
        "id": "b462247c-2445-4280-bf3a-94c0a3be298a",
        "date": "2024-02-01",
        "compensation": 2,
        "contractWorkLoad": 2,
        "submitted": false
    },
    {
        "id": "576688ce-db4c-4926-ac32-0e0e03357d7b",
        "date": "2024-02-02",
        "compensation": 8,
        "contractWorkLoad": 7,
        "submitted": false
    },
    {
        "id": "e79d462d-bfef-4345-892d-0d95fd649e4a",
        "date": "2024-02-03",
        "compensation": 1,
        "contractWorkLoad": 2,
        "submitted": true
    },
    {
        "id": "4d7c217a-1c38-40bf-a9fe-358e657b5630",
        "date": "2024-02-04",
        "compensation": 7,
        "contractWorkLoad": 8,
        "submitted": false
    },
    {
        "id": "6c7ee15f-0dee-43ff-b980-807560b5d193",
        "date": "2024-02-05",
        "compensation": 5,
        "contractWorkLoad": 6,
        "submitted": false
    },
    {
        "id": "f45b6b85-83ae-451d-a14d-3ae0d1765fb7",
        "date": "2024-02-06",
        "compensation": 3,
        "contractWorkLoad": 7,
        "submitted": true
    },
    {
        "id": "73c52624-6fb0-4e98-88cb-7d1f8225ff23",
        "date": "2024-02-07",
        "compensation": 2,
        "contractWorkLoad": 3,
        "submitted": true
    },
    {
        "id": "94e74d51-018f-4df1-89fa-12c459823e8f",
        "date": "2024-02-08",
        "compensation": 4,
        "contractWorkLoad": 8,
        "submitted": true
    },
    {
        "id": "b3536a01-e935-45f6-bcf2-143052ecb7ee",
        "date": "2024-02-09",
        "compensation": 6,
        "contractWorkLoad": 1,
        "submitted": true
    },
    {
        "id": "a2034241-0671-458a-a81f-ad739fe1f09f",
        "date": "2024-02-10",
        "compensation": 0,
        "contractWorkLoad": 8,
        "submitted": false
    },
    {
        "id": "79eb96f6-b378-4fbc-9453-0760c085c37d",
        "date": "2024-02-11",
        "compensation": 7,
        "contractWorkLoad": 5,
        "submitted": false
    },
    {
        "id": "c23314a2-7dcf-4d8f-993c-f91dcd8b47e9",
        "date": "2024-02-12",
        "compensation": 1,
        "contractWorkLoad": 2,
        "submitted": true
    },
    {
        "id": "acf0c3f2-d979-445d-9f5b-523d81bd0f3f",
        "date": "2024-02-13",
        "compensation": 3,
        "contractWorkLoad": 7,
        "submitted": true
    },
    {
        "id": "ad992622-63ca-446d-b81b-bf9db79048dc",
        "date": "2024-02-14",
        "compensation": 0,
        "contractWorkLoad": 1,
        "submitted": false
    },
    {
        "id": "764eeea2-62e7-47d5-befa-8c41f546727d",
        "date": "2024-02-15",
        "compensation": 7,
        "contractWorkLoad": 8,
        "submitted": true
    },
    {
        "id": "5ee1123c-bde2-416e-a3be-4eeb8b916c70",
        "date": "2024-02-16",
        "compensation": 4,
        "contractWorkLoad": 1,
        "submitted": true
    },
    {
        "id": "1f529930-659b-4e65-a7b8-ee42cdc2280b",
        "date": "2024-02-17",
        "compensation": 8,
        "contractWorkLoad": 5,
        "submitted": true
    },
    {
        "id": "f3ec84d2-71e8-4494-82b9-c10ab964682b",
        "date": "2024-02-18",
        "compensation": 2,
        "contractWorkLoad": 3,
        "submitted": true
    },
    {
        "id": "f0282716-61f0-4544-96f7-9803875f278b",
        "date": "2024-02-19",
        "compensation": 4,
        "contractWorkLoad": 8,
        "submitted": false
    },
    {
        "id": "a70b20a7-a802-481e-bd3b-43746b9bb2fc",
        "date": "2024-02-20",
        "compensation": 8,
        "contractWorkLoad": 3,
        "submitted": false
    },
    {
        "id": "fcf995fe-0a7d-4e2a-997d-f43185a0227c",
        "date": "2024-02-21",
        "compensation": 6,
        "contractWorkLoad": 4,
        "submitted": true
    },
    {
        "id": "15c5322d-331e-49ba-85ec-c1830cd2b35c",
        "date": "2024-02-22",
        "compensation": 6,
        "contractWorkLoad": 2,
        "submitted": true
    },
];

export default workDays.filter(day => {
    let d = new Date(day.date);
    return d.getUTCDay() !== 6;
}).map(day => {
    let we = workEntries.filter(entry => {
        let d1 = new Date(day.date);
        let d2 = new Date(entry.start);

        d1.setHours(0, 0, 0, 0);
        d2.setHours(0, 0, 0, 0);

        return d1.getTime() === d2.getTime();
    });

    let start = new Date(we[0].start)
    let end = new Date(we[we.length - 1].end)
    let date = new Date(we.date)

    return {
        id: day.id,
        date: day.date,
        compensation: "00:00:00",
        contractWorkLoad: date.getDay() === 6 ? "00:00:00" : "07:48:00",
        submitted: getStatus(day.date),
        workEntries: we,
        start: new Date(start.setHours(start.getHours() - 1)).toISOString(),
        end: new Date(end.setHours(end.getHours() + 1)).toISOString(),
    };
});

